import React, { useState, useEffect, useRef, forwardRef } from 'react';
import './TextInput.css';
import validate from '../../common/validate';
import logComponent from '../../common/logComponent';

const TextInput = forwardRef(function TextInput(props, ref) {
  const { initialValue, label, instructions, name, showError, errorMessages, rules, onValidate, onKeyDown, disabled, maxlength } = props;
  const [value, setValue] = useState(initialValue ? initialValue : '');
  const [validationDetails, setValidationDetails] = useState(null);
  const [isValid, setIsValid] = useState(null);

  if (logComponent('TextInput')) { console.debug('TextInput rendered'); }

  const valueRef = useRef((initialValue ? initialValue : ''));


  const setValueRef = (el) => {
    if (logComponent('TextInput')) { console.debug('TextInput setValueRef'); }
    valueRef.current = el;
    setValue(el);
  }

  const validationDetailsRef = useRef(null);


  const setValidationDetailsRef = (el) => {
    if (logComponent('TextInput')) { console.debug('TextInput setValueRef'); }
    validationDetailsRef.current = el;
    setValidationDetails(el);
  }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('TextInput')) { console.debug('TextInput onMount'); }
    validateThis();
  }, [])

  const updateValue = (e) => {
    if (logComponent('TextInput')) { console.debug('TextInput updateValue'); }
    setValueRef(e.target.value);
  }

  const validateThis = () => {
    if (logComponent('TextInput')) { console.debug('TextInput validateThis'); }

    let validationDetailsThis = [];
    for (let rule in rules) {
      validationDetailsThis.push({
        rule: rule,
        valid: validate[rule](valueRef.current, rules[rule])
      })
    }

    let isValidThis = validationDetailsThis.reduce((prev, curr) => prev && curr.valid, true);


    setValidationDetailsRef(validationDetailsThis);
    setIsValid(isValidThis);

    onValidate({
      name: name,
      isValid: isValidThis,
      value: valueRef.current
    });
  }



  return (
    <div className="Text-Input-Group">
      {
        showError && !isValid &&
        <React.Fragment>
          {
              validationDetailsRef.current && validationDetailsRef.current.map(detail => {

              if (detail.valid || !errorMessages || !errorMessages[detail.rule]) return null;

              return <p className="Text-Input-Group__error"
                key={validationDetails.rule} >{errorMessages[detail.rule]}</p>
            })
          }
        </React.Fragment>

      }
      <label
        className="Text-Input-Group__label"
        htmlFor={name + '-input'}>
        {label}{
          rules && rules.required &&
          <span className="Text-Input-Group__required"> *</span>
        }
      </label>

      <input
        id={name + '-input'}
        className="Text-Input-Group__input"
        type="text"
        spellCheck="false"
        value={value}
        onBlur={validateThis}
        onChange={updateValue}
        onKeyDown={onKeyDown}
        ref={ref}
        readOnly={disabled}
        maxLength={maxlength}
      />
      {
        instructions &&
        <span className="Text-Input-Group__instructions">{instructions}</span>
      }
    </div>
  );
});
export default TextInput;